import {InjectionToken} from "@angular/core";

export const MYDOCMA_SETTINGS_CONFIG = new InjectionToken('mydocma-settings-config');
export interface SettingsConfig {
  apiUrl: string;
}
